module.exports = __webpack_public_path__ + "static/media/599.7554(23).72978345.pdf";